import React from "react";
import RelatoriosIranduba from "./EstabelecimentoRelatorios/RelatoriosIranduba";
import RelatoriosRestantes from "./EstabelecimentoRelatorios/RelatoriosRestantes";

const Relatorios = () => {
    const isIranduba = localStorage.getItem("entidade_id") === "33";

    return <>{isIranduba ? <RelatoriosIranduba /> : <RelatoriosRestantes />}</>;
};

export default Relatorios;
